  document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const klaviyoForm = document.getElementById("klaviyo-form-RCUGk7");

  if(!variant.available){
    klaviyoForm.classList.remove("hide");
  }else{
    klaviyoForm.classList.add("hide");
  }
  
});

  